import React, { Component } from "react"
import { HoursIcon } from "../../icons"
import styled, { css } from "styled-components"
import { fontWeight, colors, fontSize } from "buoy-theme"
import { Paragraph, ButtonLink, Li } from "buoy-core"
import Arrow from "../../../../completion/images/Arrow"
import { getTodayDay } from "../common"

const DayText = styled(Paragraph)`
  width: 110px;
`

const HoursContainer = styled.div`
  display: flex;
  margin-left: 26px;
  margin-bottom: 2px;
  ${props =>
    props.bold
      ? css`
          > * {
            font-weight: ${fontWeight.regular};
          }
        `
      : ""};
  :last-child {
    margin-bottom: 6px;
  }
`

const ChecklistLi = styled(Li)`
  position: relative;
  padding-bottom: 6px;
  padding-left: 4px;
`

const Icon = styled.div`
  position: absolute;
  top: 5px;
  left: -21px;
`

export const SectionContainer = styled.div`
  width: 100%;
  margin-top: 16px;
`

export const ExpandArrow = styled(Arrow)`
  display: inline-flex;
  margin: 0 8px;
  vertical-align: middle;
`

export const ExpandLink = styled(ButtonLink).attrs({
  fontSize: "bodyMain",
})`
  display: flex;
  align-items: center;
  margin-top: 16px;
  width: 100%;
  ${fontSize("bodyMain")};
  color: ${props => (props.email ? colors.primary : colors.neutralDarkest)};
  text-decoration: none;
`

export const ExpandableContainer = styled.div`
  margin-bottom: 6px;
`

export const renderHours = info => {
  const dayList = []
  for (const day in info) {
    dayList.push(
      <HoursContainer key={day} bold={getTodayDay() === day}>
        <DayText>{day}</DayText>
        <Paragraph>{info[day]}</Paragraph>
      </HoursContainer>
    )
  }
  return dayList
}

class ExpandableSection extends Component {
  state = {
    expanded: false,
  }

  toggleExpanded = () => {
    this.setState({
      expanded: !this.state.expanded,
    })
  }

  render() {
    const { info, title } = this.props
    const { expanded } = this.state
    return (
      <ChecklistLi>
        <ExpandableContainer>
          <SectionContainer>
            <ExpandLink onClick={this.toggleExpanded}>
              <Icon>
                <HoursIcon />
              </Icon>
              {title}
              <ExpandArrow
                color="neutralDark"
                rotation={expanded ? "180deg" : 0}
                width="14"
                height="7"
              />
            </ExpandLink>
          </SectionContainer>
          {expanded && info && renderHours(info)}
        </ExpandableContainer>
      </ChecklistLi>
    )
  }
}

export { ExpandableSection as default }



// WEBPACK FOOTER //
// ./assets/common/components/RecommendationCard/components/ExpandableSection.js